import { FC } from 'react';

import styles from './SectionLead.module.scss';

type Props = {
  isH1Tag?: boolean;
};

const SectionLead: FC<Props> = ({ children, isH1Tag = false }) => {
  return (
    <>
      {isH1Tag ? (
        <h1 className={`${styles.section_lead}`}>{children}</h1>
      ) : (
        <h2 className={`${styles.section_lead}`}>{children}</h2>
      )}
    </>
  );
};

export default SectionLead;
